import { Routes, Route, Navigate } from 'react-router-dom'
import { SignIn, Show } from '@clerk/react'
import { AdminGate } from './components/AdminGate'
import { Layout } from './components/Layout'
import { Dashboard } from './routes/Dashboard'
import { Newsletters } from './routes/Newsletters'
import { NewsletterEdit } from './routes/NewsletterEdit'
import { PushCompose } from './routes/PushCompose'
import { PushHistory } from './routes/PushHistory'

function SignInPage() {
  return (
    <div className="grid min-h-screen place-items-center bg-bone-50 p-6 dark:bg-marrow-900">
      <div className="w-full max-w-md">
        <header className="mb-8 text-center">
          <h1 className="font-serif text-4xl font-semibold text-marrow-900 dark:text-bone-50">
            Marrow Admin
          </h1>
          <p className="mt-2 text-sm text-marrow-800/70 dark:text-bone-200/70">
            Sign in with your admin account.
          </p>
        </header>
        <SignIn routing="hash" />
      </div>
    </div>
  )
}

export default function App() {
  return (
    <>
      <Show when="signed-out">
        <Routes>
          <Route path="*" element={<SignInPage />} />
        </Routes>
      </Show>
      <Show when="signed-in">
        <AdminGate>
          <Layout>
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/newsletters" element={<Newsletters />} />
              <Route path="/newsletters/new" element={<NewsletterEdit />} />
              <Route path="/newsletters/:id" element={<NewsletterEdit />} />
              <Route path="/push" element={<PushCompose />} />
              <Route path="/push/history" element={<PushHistory />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Layout>
        </AdminGate>
      </Show>
    </>
  )
}
